import { render, staticRenderFns } from "./AgencyMinisterDonationReadOnlyView.vue?vue&type=template&id=3b0f9e45&scoped=true&"
import script from "./AgencyMinisterDonationReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./AgencyMinisterDonationReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f9e45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
installComponents(component, {VCardText})
